var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86885 8H0.666504L4 0H6L9.3334 8H7.13113L6.7213 7H3.27869L2.86885 8ZM4.09836 5H5.90163L5 2.8L4.09836 5ZM19.9999 5L15.9999 0L11.9999 5H14.9999V18H16.9999V5H19.9999ZM8.9999 10H0.999924V12H5.85414L0.999924 16V18H8.9999V16H4.14605L8.9999 12V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSortAsc);
export default __webpack_public_path__ + "static/media/text-sort-asc.c9d749f2b0cdaa99619a88c97baf9559.svg";
export { ForwardRef as ReactComponent };